<template>
    <div class="sessionBox sessionThreeBox">
        <div class="mapBox">
            <div :class="isMobile?'centerTitles':'centerTitle'">瑞和在中国</div>
            <div class="mapshowBox" v-if="!isMobile">
                <img class="mapImg" src="@/assets/index/sessionMap1.png" alt="">
                <div class="pointD" v-for="(item,index) in list" :key="index" :class="'pointD'+(index+1)" :style="{'top':item.top,'left':item.left}">
                    <div class="words">{{item.name}}</div>
                    <div class="point"></div>
                </div>
            </div>
            <div v-if="isMobile" ref="mapChart" style="width: 100vw; height: 420px;margin-top: 20px;"></div>
        </div>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import chinaJSON from '@/js/china.json'
    export default{
        data(){
            return{
                chart: null,
                allData: [
                    { 
                        name: '北京', 
                        value: [116.40, 39.90, 100] 
                    },
                    {
                        name:'通辽',
                        value:[122.16,43.37,120]
                    },
                    {
                        name:'辽宁',
                        value:[123.25,41.48,100]
                    },
                    {
                        name:'葫芦岛',
                        value:[120.51,40.45,120]
                    },
                    {
                        name:'天津',
                        value:[117.12,39.02,100]
                    },
                    {
                        name:'河北',
                        value:[114.30,38.02,100]
                    },
                    {
                        name:'太原',
                        value:[112.33,37.54,100]
                    },
                    {
                        name:'滨州',
                        value:[118.02,37.22,100]
                    },
                    {
                        name:'青岛',
                        value:[120.18,36.03,100]
                    },
                    {
                        name:'焦作',
                        value:[113.12,35.14,100]
                    },
                    {
                        name:'河南',
                        value:[113.40,34.46,100]
                    },
                    {
                        name:'开封',
                        value:[114.21,34.47,100]
                    },
                    {
                        name:'商丘',
                        value:[115.38,34.26,100]
                    },
                    {
                        name:'江苏',
                        value:[118.46,32.03,100]
                    },
                    {
                        name:'苏州',
                        value:[120.37,31.19,100]
                    },
                    {
                        name:'上海',
                        value:[121.29,31.14,100]
                    },
                    {
                        name:'成都',
                        value:[104.04,30.40,100]
                    },
                    {
                        name:'重庆',
                        value:[106.33,29.35,100]
                    },
                    {
                        name:'武汉',
                        value:[114.17,30.35,100]
                    },
                    {
                        name:'安徽',
                        value:[117.17,31.52,100]
                    },
                    {
                        name:'泸州',
                        value:[105.24,28.54,100]
                    },
                    {
                        name:'长沙',
                        value:[112.59,28.12,100]
                    },
                    {
                        name:'南昌',
                        value:[115.55,28.40,100]
                    },
                    {
                        name:'大理',
                        value:[100.13,25.34,100]
                    },
                    {
                        name:'海口',
                        value:[110.20,20.02,100]
                    },
                    {
                        name:'海南',
                        value:[109.31,18.14,100]
                    },
                ],
                list:[
                    {
                        index:0,
                        name:'通辽',
                        top:'221px',
                        left:'816px'
                    },
                    {
                        index:1,
                        name:'辽宁',
                        top:'259px',
                        left:'899px'
                    },
                    {
                        index:2,
                        name:'葫芦岛',
                        top:'299px',
                        left:'858px'
                    },
                    {
                        index:3,
                        name:'天津',
                        top:'349px',
                        left:'813px'
                    },
                    {
                        index:4,
                        name:'河北',
                        top:'366px',
                        left:'765px'
                    },
                    {
                        index:5,
                        name:'太原',
                        top:'405px',
                        left:'699px'
                    },
                    {
                        name:'滨州',
                        top:'405px',
                        left:'819px'
                    },
                    {
                        name:'青岛',
                        top:'429px',
                        left:'862px'
                    },
                    {
                        name:'焦作',
                        top:'441px',
                        left:'751px'
                    },
                    {
                        name:'河南',
                        top:'489px',
                        left:'708px'
                    },
                    {
                        name:'开封',
                        top:'471px',
                        left:'785px'
                    },
                    {
                        name:'商丘',
                        top:'502px',
                        left:'783px'
                    },
                    {
                        name:'江苏',
                        top:'476px',
                        left:'879px'
                    },
                    {
                        name:'苏州',
                        top:'515px',
                        left:'896px'
                    },
                    {
                        name:'上海',
                        top:'531px',
                        left:'925px'
                    },
                    {
                        name:'成都',
                        top:'567px',
                        left:'506px'
                    },
                    {
                        name:'重庆',
                        top:'582px',
                        left:'645px'
                    },
                    {
                        name:'武汉',
                        top:'557px',
                        left:'725px'
                    },
                    {
                        name:'安徽',
                        top:'532px',
                        left:'831px'
                    },
                    {
                        name:'泸州',
                        top:'625px',
                        left:'583px'
                    },
                    {
                        name:'长沙',
                        top:'638px',
                        left:'708px'
                    },
                    {
                        name:'南昌',
                        top:'629px',
                        left:'795px'
                    },
                    {
                        name:'大理',
                        top:'717px',
                        left:'464px'
                    },
                    {
                        name:'海口',
                        top:'828px',
                        left:'712px'
                    },
                    {
                        name:'海南',
                        top:'859px',
                        left:'695px'
                    },
                ],
                currentData: []
            }
        },
        methods:{
            initChart(){
                echarts.registerMap('china', chinaJSON)  
                this.chart = echarts.init(this.$refs.mapChart)
                const option = {
                    geo: {
                        map: 'china',
                        roam: true,
                        zoom:'1.25',
                        label: {
                            show: false
                        },
                        itemStyle: {
                            areaColor: '#F3F3F3',
                            borderColor: '#999'
                        }
                    },
                    series: [{
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        symbolSize: val => val[2] * 0.1,  // 动态尺寸:ml-citation{ref="3" data="citationList"}
                        rippleEffect: {
                            brushType: 'stroke',
                            color: '#0a78c8',
                            period: 3,
                            scale: 4
                        },
                        itemStyle:{
                            color:"#0a78c8"
                        },
                        data: this.currentData,
                        hoverAnimation: false,
                        label:{
                            show: true,
                            formatter: '{b}',
                            position: 'top',
                            fontSize: 14
                        }
                    }],
                    tooltip: {
                        trigger: 'item',
                        formatter: params => {
                            return ''
                        }
                    }
                }
                this.chart.setOption(option)
            },

            loadDataDynamic() {
                let index = 0
                const timer = setInterval(() => {
                    if (index < this.allData.length) {
                    this.currentData.push(this.allData[index])
                    this.chart.setOption({
                        series: [{ data: this.currentData }]
                    })
                    index++
                    } else {
                        clearInterval(timer)
                    }
                }, 10)
            }


        },
        mounted(){
            this.initChart()
            this.loadDataDynamic()
        },
        beforeDestroy() {
            if (this.chart) {
            this.chart.dispose()
            }
        }
    }
</script>

<style>
    .sessionBox {
        display: flex;
        justify-content: center;
    }
    .sessionThreeBox {
        width: 100%;
        background-color: #fff;
        padding-bottom: 75px;
    }
    .mapImg{
        width: 1082px;
        height: 871px;
    }
    .mapImgs{
        width: 100%;
        height: auto;
    }
    .centerTitle {
        text-align: center;
        margin-top: 68px;
        font-size: 36px;
        color: #333333;
    }
    .centerTitles{
        text-align: center;
        margin-top: 20px;
        font-size: 28px;
        color: #333333;
    }
    
    .mapshowBox{
        position: relative;
        margin-top:40px;
    }
    .pointD{
        position: absolute;
        color: #0072C6;
        font-size: 12px;
    }
    .words{
        position: absolute;
        width: 50px;
        left: 12px;
        top: -5px;
    }
    .point,.point::before,.point::after{position: absolute;width: 8px; height: 8px; border-radius: 50%;content: ''; }
    .pointD5 .point{
        width: 20px;
        height: 19px;
        background: url('../../../assets/index/star.png');
        background-size: 100% 100%;
    }
    .pointD5 .words{
        top: 15px;
        left: 0;
    }


    .pointD1 .point::before{animation: scale 5s infinite; }
    .pointD1 .point::after{animation: scale2 5s infinite; }

    .pointD2 .point::before{animation: scale 5s infinite ease-in-out 0.5s forwards; }
    .pointD2 .point::after{animation: scale2 5s infinite ease-in-out 0.5s forwards; }

    .pointD3 .point::before{animation: scale 5s infinite ease-in-out 0.8s forwards; }
    .pointD3 .point::after{animation: scale2 5s infinite ease-in-out 0.8s forwards; }

    .pointD4 .point::before{animation: scale 5s infinite ease-in-out 1.2s forwards; }
    .pointD4 .point::after{animation: scale2 5s infinite ease-in-out 1.2s forwards; }

    .pointD5 .point::before{animation: scale 5s infinite ease-in-out 1.8s forwards; }
    .pointD5 .point::after{animation: scale2 5s infinite ease-in-out 1.8s forwards; }

    .pointD6 .point::before{animation: scale 5s infinite ease-in-out 2.4s forwards; }
    .pointD6 .point::after{animation: scale2 5s infinite ease-in-out 2.4s forwards; }

    .pointD7 .point::before{animation: scale 5s infinite ease-in-out 0.5s forwards; }
    .pointD7 .point::after{animation: scale2 5s infinite ease-in-out 0.5s forwards; }

    .pointD8 .point::before{animation: scale 5s infinite ease-in-out 1.5s forwards; }
    .pointD8 .point::after{animation: scale2 5s infinite ease-in-out 1.5s forwards; }

    .pointD9 .point::before{animation: scale 5s infinite ease-in-out 2.5s forwards; }
    .pointD9 .point::after{animation: scale2 5s infinite ease-in-out 2.5s forwards; }

    .pointD10 .point::before{animation: scale 5s infinite ease-in-out 0.2s forwards; }
    .pointD10 .point::after{animation: scale2 5s infinite ease-in-out 0.2s forwards; }

    .pointD11 .point::before{animation: scale 5s infinite ease-in-out 2.5s forwards; }
    .pointD11 .point::after{animation: scale2 5s infinite ease-in-out 2.5s forwards; }

    .pointD12 .point::before{animation: scale 5s infinite ease-in-out 3.5s forwards; }
    .pointD12 .point::after{animation: scale2 5s infinite ease-in-out 3.5s forwards; }

    .pointD13 .point::before{animation: scale 5s infinite ease-in-out 0.5s forwards; }
    .pointD13 .point::after{animation: scale2 5s infinite ease-in-out 0.5s forwards; }

    .pointD14 .point::before{animation: scale 5s infinite ease-in-out 1.5s forwards; }
    .pointD14 .point::after{animation: scale2 5s infinite ease-in-out 1.5s forwards; }

    .pointD15 .point::before{animation: scale 5s infinite ease-in-out 0.5s forwards; }
    .pointD15 .point::after{animation: scale2 5s infinite ease-in-out 0.5s forwards; }

    .pointD16 .point::before{animation: scale 5s infinite ease-in-out 2s forwards; }
    .pointD16 .point::after{animation: scale2 5s infinite ease-in-out 2s forwards; }

    .pointD17 .point::before{animation: scale 5s infinite ease-in-out 2.5s forwards; }
    .pointD17 .point::after{animation: scale2 5s infinite ease-in-out 2.5s forwards; }

    .pointD18 .point::before{animation: scale 5s infinite ease-in-out 3s forwards; }
    .pointD18 .point::after{animation: scale2 5s infinite ease-in-out 3s forwards; }

    .pointD19 .point::before{animation: scale 5s infinite ease-in-out 0.5s forwards; }
    .pointD19 .point::after{animation: scale2 5s infinite ease-in-out 0.5s forwards; }

    .pointD20 .point::before{animation: scale 5s infinite ease-in-out 0.5s forwards; }
    .pointD20 .point::after{animation: scale2 5s infinite ease-in-out 0.5s forwards; }

    .pointD21 .point::before{animation: scale 5s infinite ease-in-out 1.5s forwards; }
    .pointD21 .point::after{animation: scale2 5s infinite ease-in-out 1.5s forwards; }

    .pointD22 .point::before{animation: scale 5s infinite ease-in-out 2s forwards; }
    .pointD22 .point::after{animation: scale2 5s infinite ease-in-out 2s forwards; }

    .pointD23 .point::before{animation: scale 5s infinite ease-in-out 2.5s forwards; }
    .pointD23 .point::after{animation: scale2 5s infinite ease-in-out 2.5s forwards; }

    .pointD24 .point::before{animation: scale 5s infinite ease-in-out 3s forwards; }
    .pointD24 .point::after{animation: scale2 5s infinite ease-in-out 3s forwards; }

    .pointD25 .point::before{animation: scale 5s infinite ease-in-out 0.5s forwards; }
    .pointD25 .point::after{animation: scale2 5s infinite ease-in-out 0.5s forwards; }

    @keyframes scale{
        0%{ transform: scale(1); opacity:.6} 
        100%{ transform: scale(10); opacity: 0;}}
    @keyframes scale2{
        0%{ transform: scale(1);opacity:.6;} 
        100%{ transform: scale(25);opacity:0;}
    }
    .point,.point::before,.point::after{
        background-color: rgb(0, 114, 198,.5);
    }
</style>